export type LegType = 'CL' | 'EL';

export const normalizeLegType = (value: unknown): LegType | null => {
  const normalized = String(value ?? '')
    .trim()
    .toUpperCase();
  if (normalized === 'CL' || normalized === 'EL') {
    return normalized;
  }
  return null;
};

export const filterItemsByLegType = <T extends { leg_type?: unknown }>(
  items: T[],
  activeLegType: LegType
): T[] =>
  items.filter((item) => {
    const legType = normalizeLegType(item.leg_type);
    return legType === null || legType === activeLegType;
  });

/** Reads `leg_type` (or `legType`) from a URL query string; null if absent or invalid. */
export const getLegTypeFromSearch = (search: string): LegType | null => {
  const params = new URLSearchParams(search);
  return normalizeLegType(params.get('leg_type') ?? params.get('legType'));
};
